var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('v-row',{staticStyle:{"height":"75vh"},attrs:{"align":'center',"justify":"center"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }